import { WarningTriangle } from '@byway/icons';
import clsx from 'clsx';
import { Field, getIn } from 'formik';
import PropTypes from 'prop-types';

function FormErrorMessage({ name, skipTouched = true }) {
  return (
    <Field name={name}>
      {({ form }) => {
        let error = getIn(form.errors, name);
        const touch = skipTouched || getIn(form.touched, name);
        if (Array.isArray(error)) {
          // remove empty slots
          error = error.filter(Boolean);
        }
        return touch && error ? (
          <div
            className={clsx(
              'flex items-center space-x-2 prose prose-p:mt-0 prose-a:text-status-error text-status-error',
              `validation_${name}`
            )}
          >
            <WarningTriangle ariaLabel="Error" size="large" />
            <p id={`${name}_error`} dangerouslySetInnerHTML={{ __html: error }} />
          </div>
        ) : null;
      }}
    </Field>
  );
}

FormErrorMessage.propTypes = {
  name: PropTypes.string,
  skipTouched: PropTypes.bool
};

export { FormErrorMessage };
